import gql from "graphql-tag"
import { useMutation } from "react-apollo"

import { DOCTOR_MESSAGE_FRAGMENT } from "graphql/queries/user"
import {
  SendConsultationMessageToDoctorMutation,
  SendConsultationMessageToDoctorMutationVariables
} from "typings/types"

export const SEND_CONSULTATION_MESSAGE_TO_DOCTOR = gql`
  mutation SendConsultationMessageToDoctor($consultationId: Int!, $body: String!, $from: ConsultationMessageFromEnum!) {
    sendConsultationMessage(consultationId: $consultationId, body: $body, from: $from) {
      id
      consultationMessages(newestFirst: true) {
        ...DoctorMessageFragment
      }
    }
  }
  ${DOCTOR_MESSAGE_FRAGMENT}
`

export const useSendConsultationMessage = () =>
  useMutation<SendConsultationMessageToDoctorMutation, SendConsultationMessageToDoctorMutationVariables>(
    SEND_CONSULTATION_MESSAGE_TO_DOCTOR
  )
